<div class="settings-container">
  <app-permissions-tool></app-permissions-tool>
</div>
